module.exports = __webpack_public_path__ + "static/AvenirNext-Bold-c9fba5d51ee9442afb9181f88a9c94f0.woff2";